// 系统发布环境，不填则为生产环境
const RELEASE_ENV = process.env.RELEASE_ENV;
// 系统对应的 APP 名称
const APP_NAME = process.env.APP_NAME;
// 生产环境使用二级域名，测试及其他环境使用三级域名
const env = RELEASE_ENV === 'production' ? '' : '.' + RELEASE_ENV;

const configMap = {
  // 蚁家人
  yijiahaohuo: {
    apiUrl: {
      development: `//mapi${env}.yijiahaohuo.com`,
      production: `//mapi${env}.yijiahaohuo.com`,
    },
    cdnImageDomain: 'cdnimg81.yijiahaohuo.com',
    postClassLabel: '蚁家检品',
    postAdmin: '蚁家人',
    ocAppName: 'yizhen_app',
  },
  // 质惠下单系统
  zhihuixiadan: {
    apiUrl: {
      development: `//mapi${env}.zhihuixiadan.com`,
      production: `//mapi${env}.zhihuixiadan.com`,
    },
    cdnImageDomain: 'cdnimg81.zhihuixiadan.com',
    postClassLabel: '质惠检品',
    postAdmin: '质惠下单',
    ocAppName: 'zhihui_app',
  },
  // 皮卡下单系统
  pikaxiadan: {
    apiUrl: {
      development: `//mapi${env}.pikaxiadan.com`,
      production: `//mapi${env}.pikaxiadan.com`,
    },
    cdnImageDomain: 'cdnimg81.pikaxiadan.com',
    postClassLabel: '皮卡检品',
    postAdmin: '皮卡下单',
    ocAppName: 'pika_app',
  },
  // 东升下单系统
  dongshengxiadan: {
    apiUrl: {
      development: `//mapi${env}.dongshengxiadan.com`,
      production: `//mapi${env}.dongshengxiadan.com`,
    },
    cdnImageDomain: 'cdnimg81.dongshengxiadan.com',
    postClassLabel: '东升检品',
    postAdmin: '东升下单',
    ocAppName: 'dsxd_app',
  },
  // 安特下单系统
  antexiadan: {
    apiUrl: {
      development: `//mapi${env}.antexiadan.com`,
      production: `//mapi${env}.antexiadan.com`,
    },
    cdnImageDomain: 'cdnimg81.antexiadan.com',
    postClassLabel: '安特检品',
    postAdmin: '安特下单',
    ocAppName: 'atxd_app',
  },
  // 彼选
  bixuan: {
    apiUrl: {
      development: `//mapi${env}.bixuan.net`,
      production: `//mapi${env}.bixuan.net`,
    },
    cdnImageDomain: 'cdnimg81.bixuan.net',
    postClassLabel: '彼选',
    postAdmin: '彼选',
  },
  // 亲作会员店
  qzshop: {
    apiUrl: {
      development: `//mapi${env}.qinzuo.net`,
      // 非正式环境使用 yijiahaohuo 的三级域名，正式环境使用亲作的二级域名
      production: env ? `//mapi-qz${env}.yijiahaohuo.com` : '//mapi.qinzuo.net',
    },
    cdnImageDomain: 'cdnimg81.qinzuo.net',
    postClassLabel: '亲作检品',
    postAdmin: '亲作会员店',
    ocAppName: 'qzshop',
  },
};

export const config = configMap[APP_NAME];
export const apiDomain = config.apiUrl;
export const cdnImageDomain = config.cdnImageDomain;
export const crossBorderIcon = '/icons/cross-border.png';
